function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#696969",
  fillRule: "evenodd",
  d: "M24.9 12.243c.145 0 .283.063.378.173.076.088.119.198.122.313l-.005.086-1.786 12.295c-.158 1.163-1.353 2.056-2.816 2.128l-.192.005h-8.136c-1.51 0-2.734-.826-2.981-1.984l-.027-.153-1.851-12.288c-.022-.144.02-.291.115-.401.076-.089.18-.147.293-.167l.086-.007h16.8zm-10.79-7.19l1.028-.034.748-.016c.24-.003.473-.004.71-.003l.73.01.808.022.452.015c.892.065 1.668.45 2.187 1.056.292.341.49.736.588 1.155l.76.059.666.06.608.066.585.072 1.239.172.496.071c.778.112 1.338.808 1.28 1.592-.052.738-.633 1.32-1.358 1.386l-.137.006h-18c-.786 0-1.44-.608-1.496-1.392-.054-.737.44-1.397 1.146-1.566l.135-.026 1.133-.162.837-.114c.54-.069 1.065-.127 1.697-.182l.53-.043c.296-1.21 1.35-2.124 2.628-2.205z"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.f7c37e50.svg";
export { ForwardRef as ReactComponent };